import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { fromAuth } from '@shared/store';

import { UserHeaderInfoComponent } from '../user-header-info/user-header-info.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [UserHeaderInfoComponent, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class HeaderComponent {
  store = inject(Store);

  activeUser$ = this.store.select(fromAuth.selectUser);

  businessAccountId$ = this.store.select(fromAuth.selectBusinessAccountId);
}
